export const matchEventTitles = {
    "1": "Начало на мач",
    "2": "Край на мач",
    "3": "Край на първо полувреме",
    "4": "Начало на второ полувреме",
    "5": "Край на второ полувреме",
    "6": "Начало на първо продължение",
    "7": "Край на първо продължение",
    "8": "Начало на второ продължение",
    "9": "Край на второ продължение",
    "10": "Kрай на мач след изпълнение на дузпи",
    "11": "Гол",
    "12": "Гол от дузпа",
    "13": "Автогол",
    "14": "Пропусната дузпа",
    "15": "Отменен гол",
    "16": "Смяна",
    "17": "Смяна",
    "18": "Жълт картон",
    "19": "Червен картон",
    "20": "Втори жълт картон",
    "21": "Спорна ситуация",
    "22": "Греда",
    "23": "Ъглов удар",
    "24": "Пряк свободен удар",
    "25": "Продължение",
    "26": "Фрапантен пропуск",
    "27": "Медицинска помощ",
    "28": "Изказване за мача",
    "29": "Фенове",
    "30": "",
    "31": "",
    "32": "Facebook цитат",
    "33": "Twitter цитат",
    "34": ""
};

//Променени заглавия:
//    "17": "Смяна на играч, който е влязъл от резерва",
//    "25": "Продължение /след редовно време/",
//    "28": "Изказване на косвен или пряк участник в мача",
//    "30": "Снимка",
//    "31": "Статия/аудио/галерия/видео от Gong.bg",
//    "34": "Без картинка"
